// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal{border-radius:var(--border-radius);max-height:100vh}.modal.card-container{box-shadow:none}", ""]);
// Exports
module.exports = exports;
